import { useState } from "react";
import { useIsWriteRestrictedUser } from "../../hooks/useIsWriteRestrictedUser";
import Label from "../Common/Label";

const AddpPropertyModel = ({ setShowAddPropertyModel, onSubmit }) => {
  const isActionsDisabled = useIsWriteRestrictedUser();

  const [propertyName, setPropertyName] = useState('')

  const [error, setError] = useState('');

  const handleCreateProperty = () => {
    if (isActionsDisabled) return;
    if (propertyName.trim() === '') {
      setError('Enter a property name');
      return;
    }

    setError('');
    onSubmit(propertyName);
  };

  return (
    <>
      <div className="overlayHolder bg-black/30 dark:bg-black/60 fixed inset-0 flex justify-center z-[999]" data-testid="create-property-modal">
        <div
          className="modalHlder bg-[#F8F8F8] dark:bg-darkThemeModalBg dark:shadow-darkThemeModalShadow rounded-2xl border border-black/10 max-[430px]:w-full  w-[480px] max-h-[75%]  my-auto p-10 lg:px-8 lg:py-11 overflow-auto mx-5"
        >
          <div className="flex gap-10 lg:gap-14">
            <div className="modalContent basis-full lg:basis-[344px]">
              <div className="flex flex-col gap-1">
                <h2 className="modalTitle text-[#031641] dark:text-white text-xl leading-6 lg:text-2xl lg:leading-7 font-semibold tracking-[0.036px]" data-testid="create-property-modal-title">
                  Create Property
                </h2>
                <p className="text-[#000000DE] dark:text-white text-sm leading-5 tracking-[0.021px] font-normal w-full lg:w-11/12">
                  Organize your Gradient units by location.
                </p>
              </div>
              <div className="modalFormHolder mt-6">
                <form className="space-y-5 lg:space-y-7">
                  <div className="properySection gap-1 flex flex-col">
                    <div className="flex flex-col gap-1 relative">
                      <Label
                        htmlFor="propertyName"
                        className="propertyName text-[#00000099] dark:text-white font-normal text-base leading-5 tracking-[-0.24px]"
                      >
                        Property Name
                      </Label>
                      <input
                        id="propertyName"
                        type="text"
                        placeholder="Enter Property Name"
                        name="name"
                        className="w-full text-lg leading-6 py-2.5 px-3 rounded-md border border-[#CADBD5] text-dark-grey h-11 bg-white dark:darkThemeGradiantBg dark:text-white dark:border-none placeholder:text-dark-grey/40 dark:placeholder:text-white/40 font-medium tracking-[-0.408px] outline-none max-w-[300px]"
                        value={propertyName}
                        onChange={(e) => {
                          setPropertyName(e.target.value);
                          if (error) setError(''); // Clear error on input
                        }}
                        data-testid="create-property-modal-input"
                      />
                      {error && (
                        <p className="text-critical text-xs leading-4 absolute -bottom-5" data-testid="create-property-modal-error">{error}</p>
                      )}
                    </div>
                  </div>
                </form>
              </div>
              <div className="mt-10 actionsHolder">
                <div className="flex items-center  gap-4 lg:gap-6">
                  <button
                    onClick={handleCreateProperty}
                    className={`flex justify-center items-center basis-36 md:basis-1/2 grow-0 md:grow shrink bg-theme px-5 py-3 text-white text-base font-semibold leading-5 tracking-[-0.32px] rounded-md h-10 hover:bg-theme/80 transition-all duration-300 ease-in-out ${
                      isActionsDisabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
                    }`}
                    disabled={isActionsDisabled}
                    data-testid="create-property-modal-save"
                  >
                    Save
                  </button>
                  <button onClick={() => setShowAddPropertyModel(false)} className="flex justify-center items-center basis-36 md:basis-1/2 grow-0 md:grow shrink border border-theme px-5 py-3 text-theme text-base font-semibold leading-5 tracking-[-0.32px] rounded-md cursor-pointer h-10 hover:bg-theme hover:text-white transition-all duration-300 ease-in-out" data-testid="create-property-modal-cancel">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddpPropertyModel;
